import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DataService } from '../../service/deviceservice';
// Component for handling redirecting from legacy /showFrame route to the new home route
export const ShowFrameRedirect = () => {
    const dataService = new DataService();
    React.useEffect(() => {
        let redirectUrl = window.location.origin + '/t/' + dataService.getTenantIdMasked();
        if (dataService.getDeviceType() === 'webex') {
            redirectUrl +=
                '?deviceId=' +
                    dataService.getDeviceId() +
                    '&orgId=' +
                    dataService.getOrgId();
        }
        setTimeout(() => {
            window.location.replace(redirectUrl);
        }, 1000);
    }, []);
    return _jsx(_Fragment, {}); // Render nothing as we are redirecting
};
